
      let Page = require('/home/toannc/ekmap-platform-map-javascript/docs/pages/services/protected_area_service.md');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "title": "Thông tin khu vực bảo tồn",
    "description": "Dịch vụ cung cấp thông tin về khu vực bảo tồn.",
    "topics": [
      "Service"
    ],
    "thumbnail": "protected-area",
    "order": 5,
    "contentType": "example",
    "layout": "page",
    "hideFeedback": false,
    "language": [
      "JavaScript"
    ],
    "products": [
      "Mapbox GL JS"
    ],
    "prependJs": [
      "import Example from '../../components/example';",
      "import html from './protected_area_service.html';"
    ]
  }
}
      };
    